export const tableSx = { minWidth: 800, height: '403px' };
export const tableCellSx = { py: 3 };

export const TABLE_HEAD = [
  { id: 'name', label: 'First Name', alignRight: false },
  { id: 'lastName', label: 'Last Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'role', label: 'Role', alignRight: false },
];
